import axios from "axios";

// #11/#12/#19 - Docusign signing API. Mirrors the backend signing controller
// (shared by contract and Add State). Outside production the signing URL points
// at our own mock page; only production talks to real Docusign.
//
// The same endpoints back both flows, at different bases:
//   /api/unsigned-contract-request   (contract request)
//   /api/unsigned-add-state-request  (Add State, #19)
export function makeDocusignService(apiBase) {
  // Start (or resume, when unsignedId is set) signing for the in-progress wizard
  // data. Returns { id, signingUrl }.
  const startSigning = (data) =>
    axios.post(`${apiBase}/start-signing`, { ...data }).then((r) => r.data);

  // Envelope status (+ the stored payload, for rehydrating the wizard on return).
  const getStatus = (id) =>
    axios.get(`${apiBase}/${id}/status`).then((r) => r.data);

  // Mock-only: complete or abandon signing from the mock Docusign page.
  const mockSign = (id) =>
    axios.post(`${apiBase}/${id}/mock-sign`).then((r) => r.data);

  const mockCancel = (id) =>
    axios.post(`${apiBase}/${id}/mock-cancel`).then((r) => r.data);

  // Admin (#12): email the agent a link to finish signing.
  const sendReminder = (id) =>
    axios.post(`${apiBase}/${id}/send-reminder`).then((r) => r.data);

  // #115 - archive a superseded abandoned signing attempt off the unfinished list.
  const archive = (id) =>
    axios.post(`${apiBase}/${id}/archive`).then((r) => r.data);

  // #65 - the request's single release-letter signing. startReleaseSigning returns
  // { id, signingUrl }; getReleaseStatus returns { id, payload, release }.
  const startReleaseSigning = (data) =>
    axios.post(`${apiBase}/release/start-signing`, { ...data }).then((r) => r.data);

  const getReleaseStatus = (id) =>
    axios.get(`${apiBase}/${id}/release-status`).then((r) => r.data);

  const mockReleaseSign = (id) =>
    axios.post(`${apiBase}/${id}/release/mock-sign`).then((r) => r.data);

  return {
    startSigning,
    getStatus,
    mockSign,
    mockCancel,
    sendReminder,
    archive,
    startReleaseSigning,
    getReleaseStatus,
    mockReleaseSign,
  };
}

// #19 - the Add State signing service (used by the Add State DocuSign step and
// its signing-return page).
export const addStateDocusignService = makeDocusignService(
  "/api/unsigned-add-state-request"
);

const DocusignService = makeDocusignService("/api/unsigned-contract-request");

export default DocusignService;
